export default {
    savePlace: 'บันทึกสถานที่',
    searchByName: 'ค้นหาโดยชื่อ',
    search: 'ค้นหา',
    create: 'สร้างสถานที่',
    namePlace: 'ชื่อสถานที่',
    latitude: 'ละติจูด',
    longitude: 'ลองจิจูด',
    radian: 'รัศมี (เมตร)',
    congratulation: 'ยินดีด้วย',
    deletePlace: 'ลบสถานที่',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบสถานที่',
    placeIsDeleted: 'สถานที่ถูกลบแล้ว'
}
